(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kt-bf"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-kt-bf-add]');
    if (!btn) return;
    const box = btn.closest('[data-kt-bf]');
    const msg = box && box.querySelector('.kt-bf__msg');
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.ktBfAdd), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Error');
      const cart = await (await fetch(root + 'cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'kt-bf', data: { source: 'kt-bf', itemCount: cart.item_count } },
      }));
      if (msg) msg.innerHTML = `Regalo añadido ✓ Añade también el kamado y te sale gratis. <a href="${root}cart">Ver carrito</a>`;
    } catch (err) {
      if (msg) msg.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      btn.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kt-complete"] && !Shopify.designMode) return;
  try {
    (() => {
    const money = (cents) =>
      (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    const update = (form) => {
      const boxes = [...form.querySelectorAll('input[type=checkbox]:checked')];
      const total = boxes.reduce((t, b) => t + Number(b.dataset.price), 0);
      form.querySelector('[data-total]').textContent = money(total);
      form.querySelector('button').disabled = boxes.length === 0;
    };
    const init = () => document.querySelectorAll('[data-kt-complete]').forEach(update);
    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-kt-complete]');
      if (form) update(form);
    });
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-kt-complete]');
      if (!form) return;
      e.preventDefault();
      const items = [...form.querySelectorAll('input[type=checkbox]:checked')].map((b) => ({ id: Number(b.value), quantity: 1 }));
      if (!items.length) return;
      const btn = form.querySelector('button');
      const msg = form.querySelector('.kt-complete__msg');
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      btn.disabled = true;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        const cart = await (await fetch(root + 'cart.js')).json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'kt-complete', data: { source: 'kt-complete', itemCount: cart.item_count } },
        }));
        msg.innerHTML = `Añadido al carrito ✓ <a href="${root}cart">Ver carrito</a>`;
      } catch (err) {
        msg.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      }
      btn.disabled = false;
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
